(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["pb-product-highlights"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('pb-feature-strip')) {
    customElements.define('pb-feature-strip', class extends HTMLElement {
      connectedCallback() {
        if (this.pbFeatureAbort) return;
        const track = this.querySelector('[data-pb-feature-track]');
        const controls = this.querySelector('[data-pb-feature-controls]');
        const previous = this.querySelector('[data-pb-feature-previous]');
        const next = this.querySelector('[data-pb-feature-next]');
        const position = this.querySelector('[data-pb-feature-position]');
        if (!track || !controls || !previous || !next || !position) return;
        const items = Array.from(track.children);
        if (!items.length) return;
        this.pbFeatureAbort = new AbortController();
        const options = { signal: this.pbFeatureAbort.signal };
        const currentIndex = () => {
          const maximum = Math.max(0, track.scrollWidth - track.clientWidth);
          if (maximum > 1 && track.scrollLeft >= maximum - 1) return items.length - 1;
          return items.reduce((best, item, index) => Math.abs(item.offsetLeft - track.scrollLeft) < Math.abs(items[best].offsetLeft - track.scrollLeft) ? index : best, 0);
        };
        const update = () => {
          const maximum = Math.max(0, track.scrollWidth - track.clientWidth);
          controls.hidden = maximum <= 1;
          previous.disabled = track.scrollLeft <= 1;
          next.disabled = track.scrollLeft >= maximum - 1;
          const text = position.dataset.positionTemplate.replace('[current]', String(currentIndex() + 1)).replace('[total]', String(items.length));
          if (position.textContent !== text) position.textContent = text;
        };
        const goTo = (index) => {
          const target = items[Math.max(0, Math.min(index, items.length - 1))];
          const maximum = Math.max(0, track.scrollWidth - track.clientWidth);
          track.scrollTo({ left: Math.min(target.offsetLeft, maximum), behavior: 'instant' });
          update();
        };
        const step = (direction) => {
          let target = direction < 0 ? 0 : items.length - 1;
          for (let index = 0; index < items.length; index += 1) {
            if (direction < 0 && items[index].offsetLeft < track.scrollLeft - 1) target = index;
            if (direction > 0 && items[index].offsetLeft > track.scrollLeft + 1) {
              target = index;
              break;
            }
          }
          goTo(target);
        };
        previous.addEventListener('click', () => step(-1), options);
        next.addEventListener('click', () => step(1), options);
        track.addEventListener('keydown', (event) => {
          if (event.target !== track || event.altKey || event.ctrlKey || event.metaKey || event.shiftKey) return;
          if (event.key === 'ArrowLeft') step(-1);
          else if (event.key === 'ArrowRight') step(1);
          else if (event.key === 'Home') goTo(0);
          else if (event.key === 'End') goTo(items.length - 1);
          else return;
          event.preventDefault();
        }, options);
        document.addEventListener('pb:locale-change', update, options);
        track.addEventListener('scroll', () => {
          clearTimeout(this.pbFeatureTimer);
          this.pbFeatureTimer = setTimeout(update, 120);
        }, { ...options, passive: true });
        if ('ResizeObserver' in window) {
          this.pbFeatureResize = new ResizeObserver(update);
          this.pbFeatureResize.observe(track);
        } else {
          window.addEventListener('resize', update, options);
        }
        update();
      }
      disconnectedCallback() {
        this.pbFeatureAbort?.abort();
        this.pbFeatureAbort = null;
        this.pbFeatureResize?.disconnect();
        this.pbFeatureResize = null;
        clearTimeout(this.pbFeatureTimer);
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
